
// src/web/components/diary-report-graph.jsx

import React from 'react'
import ChartView from 'react-highcharts'
import { themr } from 'react-css-themr'
import {Button} from "react-toolbox/lib/button";
import connect from "../../connects/diary-report-graph";
import diaryReportTheme from './themes/diary-report.css'
import { eventEmitter } from "../../connects/eventEmitter"

@themr('DiaryReportGraph', diaryReportTheme)
class DiaryReportGraph extends React.Component {

  render() {
    const {
      t,
      theme,
      group,
      diary,
      user,
      attach_json,
      openGroupSettingsPage,
      openReportStatusPage,
    } = this.props

    if (!attach_json)
      return null

    const {
      report_data
    } = attach_json
    if (!report_data || Object.keys(report_data) == 0)
      return null

    const {
      graph_data
    } = report_data
    if (!graph_data || Object.keys(graph_data) == 0)
      return null

    const membership = user.group_memberships.find(membership => membership.group_id === group.group_id);
    const isGroupAdmin = membership ? membership.admin : false;

    return (
      <div className={theme.report}>
        <div
          style={{marginLeft: '20px', marginRight: '20px', paddingLeft: '20px', paddingRight: '20px', width: '100%'}}>
          <ChartView config={graph_data}/>
        </div>
        <div style={{marginLeft: '20px', marginBottom: '20px'}}>
        {
          group && group.group_id && !diary.group && isGroupAdmin &&
          (<div>
            <Button key={1} raised onClick={openGroupSettingsPage} icon="edit" style={{marginRight: '10px', marginBottom: '20px'}} label={t('label:設定')}/>
            <Button key={2} raised onClick={() => {
                openReportStatusPage(); 
                 setTimeout(() => {
                    const emitted = eventEmitter.emit("updateShowDownloadState", { showDownload: true });
                  }, 500); // Adjust the delay as needed
                }
              } 
              icon="check_box" 
              style={{marginRight: '10px', marginBottom: '20px'}} 
              label={t('label:提出状況')}
            />
          </div>)
        }
          {/*<Button key={3} raised icon="book" style={{marginRight: '10px', marginBottom: '20px'}} label={t('label:週の投稿', {week_number:1})}/>*/}
        </div>
      </div>
    )
  }
}

export default connect(DiaryReportGraph)



// WEBPACK FOOTER //
// ./src/web/components/diary-report-graph.jsx